import { render } from "./ProjectCanvas.vue?vue&type=template&id=09102001&scoped=true"
import script from "./ProjectCanvas.vue?vue&type=script&lang=js"
export * from "./ProjectCanvas.vue?vue&type=script&lang=js"

import "./ProjectCanvas.vue?vue&type=style&index=0&id=09102001&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09102001"]])

export default __exports__